import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.waNumber)
    ? (_openBlock(), _createElementBlock("a", {
        key: 0,
        href: _ctx.waLink,
        target: "_blank",
        rel: "noopener noreferrer",
        class: "wa-float",
        "aria-label": "Chat on WhatsApp"
      }, _cache[0] || (_cache[0] = [
        _createElementVNode("svg", {
          viewBox: "0 0 32 32",
          xmlns: "http://www.w3.org/2000/svg",
          fill: "currentColor"
        }, [
          _createElementVNode("path", { d: "M16 0C7.163 0 0 7.163 0 16c0 2.823.738 5.47 2.027 7.774L0 32l8.476-2.001A15.93 15.93 0 0 0 16 32c8.837 0 16-7.163 16-16S24.837 0 16 0zm0 29.333a13.27 13.27 0 0 1-6.76-1.847l-.484-.287-5.03 1.187 1.213-4.895-.314-.503A13.257 13.257 0 0 1 2.667 16C2.667 8.636 8.636 2.667 16 2.667S29.333 8.636 29.333 16 23.364 29.333 16 29.333zm7.27-9.865c-.398-.2-2.354-1.162-2.719-1.294-.366-.133-.632-.2-.898.2-.265.398-1.03 1.294-1.263 1.56-.232.265-.465.298-.863.1-.398-.2-1.68-.619-3.2-1.976-1.183-1.056-1.981-2.36-2.213-2.758-.232-.398-.025-.613.175-.81.179-.178.398-.465.597-.697.2-.232.265-.398.398-.664.133-.265.067-.497-.033-.697-.1-.2-.898-2.164-1.23-2.963-.324-.778-.653-.673-.898-.685l-.764-.013c-.265 0-.697.1-.1063.497-.366.398-1.396 1.362-1.396 3.32 0 1.958 1.43 3.849 1.628 4.115.2.265 2.814 4.298 6.817 6.028.953.411 1.697.657 2.277.841.957.304 1.828.261 2.516.158.767-.114 2.354-.963 2.687-1.892.332-.93.332-1.726.232-1.892-.1-.166-.366-.265-.764-.465z" })
        ], -1),
        _createElementVNode("span", { class: "wa-tooltip" }, "Chat with us", -1)
      ]), 8, _hoisted_1))
    : _createCommentVNode("", true)
}